export enum ChangeBillerOfferStep {
  INFO = 'info',
  PHONE_NUMBER = 'phoneNumber',
  SUMMARY = 'summary',
}
